<template>
  <div class="place">
    <el-breadcrumb separator="">
      <b></b>
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="index">
        <i class="el-icon-arrow-right" style="margin-right:3px;" v-if="index>0"></i>
        <router-link v-if="item.path==''" to="/index"   tag="a" class="navigation">{{item.name}}</router-link>
        <!-- <router-link v-else :to="item.path"   tag="a" class="navigation">{{item.name}}</router-link> -->
        <span v-else>{{item.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        111<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item,i) in list"  :key="item.id" :command="item.selectLessonId">{{item.name}}</el-dropdown-item> 
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>
<script>

export default {
  name: 'Breadcrumb',
  data () {
    return {
      levelList: null,

    }
  },
  props: ['list'],
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
 
  created () {
    this.getBreadcrumb()
    
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => {
        if(item.path=='/article'||item.path=='/xuanke'){
          item.name=this.$route.query.name||this.$route.query.title
        }
        if (item.name) {
          return true
        }
      })

      this.levelList = matched
    },
    handleCommand(command) {
        this.$message('click on item ' + command);
      }

  }
}
</script>
<style scoped lang="less">
.place {
  background-color: #fff;
  overflow: hidden;
  border-bottom:1px solid #E5E5E5;
 .el-breadcrumb{
  margin:18Px 0 14Px;
  font-size:16Px;
 }
 b{
  width: 3Px;
  height:16Px;
  display:inline-block;
  background-color: rgba(32, 147, 255, 1);
  float:left;
  margin-right:10px;
 }
}

 .el-breadcrumb__inner{
  color:#000000!important;
  &:first-child{
    position:relative;
    top:2Px;
  }
}
.el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
  color:#999;
  font-weight:400;
}
.el-breadcrumb__item:last-child .__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color:#191919;
  position:relative;
    top:-1Px;
}
.el-breadcrumb__item{
    position:relative;
    margin-right:5Px;
    max-width:350Px;
      overflow:hidden; 
    text-overflow:ellipsis; 
    white-space:nowrap; 

  }

</style>

